import { setDatadogRumContext, sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import { initializeSharing } from "app/scripts/sharing"

import "stylesheets/story.scss"

sharedVanillaSetup()

document.addEventListener("DOMContentLoaded", function() {
  setDatadogRumContext("key-page", "story-show")

  initializeSharing()
}, { once: true })
